import Main from './views/Main.vue';
import Tech from './views/Tech.vue';
import Portfolio from './views/Portfolio.vue';
import PortfolioDetail from './views/PortfolioDetail.vue';
import Price from './views/Price.vue';
import About from './views/About.vue';

import { createRouter, createWebHistory } from 'vue-router';
import store from './store';

const beforeEnterGuard = async (to, from) => {
    if (!store.state.isLoggedIn) {
        const isAuthorized = await store.dispatch('isAuthorized');
        if (!isAuthorized) return { path: '/login' };
    }
};

const routes = [
    {
        path: '/index.html',
        component: Main,
        beforeEnter: async (to, from) => {
            if (localStorage.getItem('isLoggedIn')) {
                await store.dispatch('isAuthorized');
            }
        },
    },
    {
        path: '/',
        component: Main,
        beforeEnter: async (to, from) => {
            if (localStorage.getItem('isLoggedIn')) {
                await store.dispatch('isAuthorized');
            }
        },
    },
    {
        path: '/tech',
        component: Tech,
        beforeEnter: async (to, from) => {
            if (localStorage.getItem('isLoggedIn')) {
                await store.dispatch('isAuthorized');
            }
        },
    },
    {
        path: '/portfolio',
        component: Portfolio,
        beforeEnter: async (to, from) => {
            if (localStorage.getItem('isLoggedIn')) {
                await store.dispatch('isAuthorized');
            }
        },
    },
    
    {
        path: '/portfolio/detail/:id',
        component: PortfolioDetail,
        beforeEnter: async (to, from) => {
            if (localStorage.getItem('isLoggedIn')) {
                await store.dispatch('isAuthorized');
            }
        },
    },
    {
        path: '/price',
        component: Price,
        beforeEnter: async (to, from) => {
            if (localStorage.getItem('isLoggedIn')) {
                await store.dispatch('isAuthorized');
            }
        },
    },
    {
        path: '/about',
        component: About,
        beforeEnter: async (to, from) => {
            if (localStorage.getItem('isLoggedIn')) {
                await store.dispatch('isAuthorized');
            }
        },
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, SavedPosition) {
        // console.log('scrollBehavior', to, from, SavedPosition)
        document.getElementById('app').scrollTo(0,0)
        return { 
            top: 0 ,
            behavior: 'smooth',
        }
    }
});

export default router;
